import React from "react";

// components
import BlogCard from "../misc/BlogCard";

// constants and icon
import { IoDuplicateOutline } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";

// router
import { useNavigate } from "react-router-dom";

// state and service
import { get_blogs } from "../../../services/apis/blog";
import { useAppDispatch, useAppSelector } from "../../../store";
import Button from "../../../component/element/forms/Button";

const Blog = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const blogs = useAppSelector(({ blog }) => blog?.blogs);
  // const loading = useAppSelector(({ blog }) => blog?.loading);

  const onLoad = React.useCallback(() => {
    get_blogs(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="w-full">
      <div className="w-full flex justify-between items-center mb-6">
        <h2 className="font-bold text-xl capitalize mb-0">Blogs</h2>

        <div className="flex items-center gap-x-2">
          <Button
            title="Create"
            children={<FaPlus className="mr-2" />}
            onClick={() => navigate("/blog/create")}
            className="px-4"
          />

          <Button
            title="Categories"
            children={<IoDuplicateOutline className="mr-2" />}
            onClick={() => navigate("/blog/categries")}
            className="text-white"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {blogs.map((item) => (
          <BlogCard data={item} key={item.id} />
        ))}
      </div>
    </div>
  );
};

export default Blog;
